module.exports = __webpack_public_path__ + "img/hr-tree-02-e-leaves.543cbd43.png";